import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import AppVideo from '@/pages/AppVideo'
import NewAppVideo from '@/pages/NewAppVideo'
import AudioPath from '@/pages/AudioPath'
import ScienceDetail from '@/pages/ScienceDetail'
import NewIndex from '@/pages/new/Index'
import NewAbout from '@/pages/new/About'
import Story from '@/pages/new/Story'
import Buy from '@/pages/new/Buy'
import News from '@/pages/new/News'
import InstrumentIndex from '@/pages/new/InstrumentIndex'
import InstrumentMore from '@/pages/new/InstrumentMore'
import ServiceCenter from '@/pages/new/ServiceCenter'
import NotFind from '@/pages/NotFind'
import DownLoadApp from '@/pages/DownLoadApp'

Vue.use(Router)

export default new Router({
  mode: 'history', //history模式支持不带#，但服务器需要做相应配置
  routes: [
    {
      path: '/',
      name: 'Index',
      component: NewIndex,
    },
    {
      path: '/appVideo/:vId',
      name: 'AppVideo',
      component: AppVideo,
    },
    {
      path: '/newAppVideo/:vm/:vId',
      name: 'NewAppVideo',
      component: NewAppVideo,
    },
    {
      path: '/audioPath/:am/:aSubM/:aId',
      name: 'AudioPath',
      component: AudioPath,
    },
    {
      path: '/scienceDetail/:id',
      name: 'ScienceDetail',
      component: ScienceDetail,
    },
    {
      path: '/index',
      name: 'Index',
      component: NewIndex,
    },
    {
      path: '/about',
      name: 'About',
      component: NewAbout,
    },
    {
      path: '/story',
      name: 'Story',
      component: Story,
    },
    {
      path: '/buy',
      name: 'Buy',
      component: Buy,
    },
    {
      path: '/news',
      name: 'News',
      component: News,
    },
    {
      path: '/instrumentIndex',
      name: 'InstrumentIndex',
      component: InstrumentIndex,
    },
    {
      path: '/instrumentMore',
      name: 'InstrumentMore',
      component: InstrumentMore,
    },
    {
      path: '/serviceCenter',
      name: 'ServiceCenter',
      component: ServiceCenter,
    },
    {
      path: '/index.html',
      redirect: {
        name: "Index"
      },
      component: Index,
      meta: {
        title: '雅致健康'
      },
    },
    {
      path: '/mobile/app.html',
      name: 'DownLoadApp',
      component: DownLoadApp,
      meta: {
        title: '雅致健康'
      },
    },
    {
      path: '/NotFind',
      name: 'NotFind',
      component: NotFind,
      meta: {
        title: '404页面',
      },
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js